export const generateDeferredPromise = <T>() => {
    let dResolve: (value: T | PromiseLike<T>) => void
    let dReject: (value: T | PromiseLike<T>) => void
    const deferredPromise = new Promise<T>((resolve, reject) => {
        dResolve = resolve
        dReject = reject
    })

    return {
        promise: deferredPromise,
        reject: dReject,
        resolve: dResolve,
    }
}
